import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import VueScrollTo from 'vue-scrollto';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { datadogRum } from '@datadog/browser-rum';

import './index.css';
import bodyScrollLock from '@/utils/directives/bodyScrollLock.js';
import clickOutside from '@/utils/directives/clickOutside.js';
import router from './router';
import App from './App.vue';

const app = createApp(App);
app.use(router);
app.use(VueScrollTo, {
  offset: -40,
});

// Directives
app.directive('body-scroll-lock', bodyScrollLock);
app.directive('click-outside', clickOutside);

router.isReady().then(function () {
  app.mount('#app');
});

const envObj = {
  'seller.dev.imitsu-cloud.jp': 'development',
  'seller.stg.imitsu-cloud.jp': 'staging',
  'seller.imitsu-cloud.jp': 'production',
};

let parts = window.location.hostname.split('.');
let hostname =
  parts[0].includes('seller') && parts[1] === 'dev'
    ? 'seller.dev.imitsu-cloud.jp'
    : window.location.hostname;
let environment = envObj[hostname] ? envObj[hostname] : 'local';

let gtmId = null;

switch (environment) {
  case 'production':
    gtmId = 'GTM-M9M93B3';
    break;
  case 'development':
    gtmId = 'GTM-5HGH2V7';
    break;
  case 'local':
    gtmId = 'GTM-PTLV7WJ';
    break;
}

if (gtmId) {
  app.use(
    createGtm({
      id: gtmId,
      queryParams: {},
      defer: false,
      compatibility: false,
      nonce: '2726c7f26c',
      enabled: true,
      // debug: true, // optional
      // loadScript: true, // optional
      vueRouter: router, // optional
      // ignoredViews: [], // optional
      trackOnNextTick: false,
    })
  );
}

if (['development', 'staging', 'production'].includes(environment)) {
  Sentry.init({
    app,
    dsn: 'https://ade865f2ebb8466ebd23c394f5912e3b@o562685.ingest.sentry.io/5701629',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    environment: environment + '-seller',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

  datadogRum.init({
    applicationId: '27a0fb8f-c689-4027-a39d-ee5a926560a8',
    clientToken: 'pub2f83ddd98f79c285076902009f243e34',
    site: 'datadoghq.com',
    sampleRate: 100,
    trackInteractions: true,
    service: 'ic-seller',
    env: environment,
    allowedTracingOrigins: [
      'https://seller.imitsu-cloud.jp',
      'https://seller.imitsu-cloud.jp:1443',
      'https://seller.stg.imitsu-cloud.jp',
      'https://seller.stg.imitsu-cloud.jp:1443',
    ],
  });
}

// createApp(App)
//   .use(router)
//   .mount("#app");
